<template>
  <div class='InputCaracterItem'>
    <div class="cont-icon">
      <component :is="data.icon"/>
    </div>
    <div class="cont-input">
      <input :value="Value" @change="e => UpdateCaracterProd({ icon: data.icon, name: e.target.value })" type="text" :placeholder="data.placeholder">
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LocationIcon from '../../Icons/LocationIcon'
import RoomsIcon from '../../Icons/RoomsIcon'
import ToiletIcon from '../../Icons/ToiletIcon'
import ParkingIcon from '../../Icons/ParkingIcon'
import AreaIcon from '../../Icons/AreaIcon'
export default {
  name: 'InputCaracterItem',
  components: { LocationIcon, RoomsIcon, ToiletIcon, ParkingIcon, AreaIcon },
  props: {
    data: {
      type: Object,
      default: () => ({ icon: 'LocationIcon', placeholder: 'Endereço' })
    }
  },
  computed: {
    ...mapGetters(['SelectedProdEdit']),
    Value () {
      let value = this.SelectedProdEdit.caracter.length ? this.SelectedProdEdit.caracter.filter(c => c.icon === this.data.icon) : []
      return value.length ? value[0].name : ''
    }
  },
  methods: {
    ...mapActions(['UpdateCaracterProd'])
  }
}
</script>

<style scoped>
.InputCaracterItem {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 2%;
}

.cont-icon {
  width: 5%;
}

.cont-input {
  width: 95%;
}

input {
  border: thin solid #CCC;
  border-radius: 5px;
  font-size: 18px;
  padding: 10px;
  width:97%;
}

@media (max-width: 500px) {
  input {
    width: 90%;
  }
}
</style>
